export * from './DocIcon';
export * from './DocIcon16Light';
export * from './DocIcon16Regular';
export * from './DocIcon16Solid';
export * from './DocIcon20Light';
export * from './DocIcon20Regular';
export * from './DocIcon20Solid';
export * from './DocIcon24Regular';
export * from './DocIcon24Solid';
export * from './DocIcon32Regular';
export * from './DocIcon64Regular';
